module.exports = __webpack_public_path__ + "static/media/hotel-1.d109393b.jpg";